/**
 * /bayilik — Kurye şirketi / bayilik reklam landing'i (zengin sürüm).
 *
 * Tek hedef: "company" (Kurye Şirketi) başvuru formu (ApplicationModal).
 * Ürün, kod içi animasyonlu mockup'larla görselleştirilir (BayilikMockups).
 * Reklam ölçümü: UTM yakalama (mount) + dönüşüm olayı (ApplicationModal success).
 *
 * Metinler İLK TASLAK — Onur'un nihai mesaj/rakam/teklifi ile güncellenecek.
 */
import { useState, useEffect } from 'react';
import {
  Zap, Route, Coins, MapPin, CalendarClock, Receipt, FileCheck2, Plug,
  Smartphone, Wallet, ArrowRight, Store, Code2, CheckCircle2,
  Sparkles, Headset,
} from 'lucide-react';

import { HeaderV2 } from '../components/landing-v2/HeaderV2';
import { Footer } from '../components/Footer';
import { ApplicationModal } from '../components/ApplicationModal';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { Toaster } from '../components/ui/sonner';
import { Button } from '../components/ui/button';
import { LANDING_IMAGES } from '../lib/landingImages';
import {
  PhoneApp, CourierApp, Dashboard, Counter, Reveal,
  MiniJeton, MiniVardiya, MiniMutabakat,
} from '../components/bayilik/BayilikMockups';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
function captureUtm() {
  try {
    const sp = new URLSearchParams(window.location.search);
    const utm = {};
    UTM_KEYS.forEach((k) => { const v = sp.get(k); if (v) utm[k] = v; });
    if (Object.keys(utm).length) {
      utm.ts = new Date().toISOString();
      utm.landing = window.location.pathname;
      localStorage.setItem('agros_utm', JSON.stringify(utm));
    }
  } catch { /* sessiz */ }
}

const OZELLIKLER = [
  { icon: Zap, baslik: 'Otomatik Atama', metin: 'Sipariş düştüğü an en uygun kuryeye saniyeler içinde, elle uğraşmadan atanır.' },
  { icon: Route, baslik: 'Akıllı Rota & Optimizasyon', metin: 'OSRM tabanlı AI; mesafe, adalet ve maliyeti birlikte hesaplayıp en verimli dağıtımı kurar.' },
  { icon: Coins, baslik: 'Jeton (Kontör) Sistemi', metin: 'Her teslimat kontörle işler; bakiye, otomatik düşüm ve işlem geçmişi şeffaf şekilde panelde.' },
  { icon: MapPin, baslik: 'Canlı Takip & Yol Tarifi', metin: 'Kuryeyi haritada canlı izle; dönüş yol tarifi, yol uyarıları ve teslimat durumu.' },
  { icon: CalendarClock, baslik: 'Vardiya & Rütbe', metin: 'Haftalık vardiya planı, check-in, takas, rütbe ve performans puanı.' },
  { icon: Receipt, baslik: 'POS Mutabakat', metin: 'Günlük mutabakat, Cep POS ve nakit/kart takibi sipariş bazında.' },
  { icon: FileCheck2, baslik: 'e-Fatura (eLogo)', metin: 'Entegre e-fatura; hakediş, muhasebe ve tahsilat takibi tek yerde.' },
  { icon: Plug, baslik: 'Platform Entegrasyonları', metin: 'Getir, Trendyol, Migros, Yemeksepeti, Adisyo siparişleri aynı panele düşer.' },
  { icon: Smartphone, baslik: '3 Uygulama Hazır', metin: 'Yönetici paneli + kurye uygulaması + müşteri uygulaması (Agros Kapında) kutudan çıkar.' },
  { icon: Wallet, baslik: 'Tahsilat & Muhasebe', metin: 'Kurye hakedişi, bakiye, borç/alacak ve kâr-zarar raporları otomatik.' },
];

const GUVEN = [
  { n: 3, suffix: '+', l: 'Yıl saha deneyimi' },
  { n: 30, suffix: '+', l: 'Platform & servis entegrasyonu' },
  { n: 3, suffix: '', l: 'Uygulama (yönetici·kurye·müşteri)' },
  { n: 7, suffix: '/24', l: 'Teknik & operasyon desteği' },
];

const MODELLER = [
  { icon: Store, renk: 'orange', baslik: 'Franchise + Yazılım', ozet: 'AgrosJet markasıyla bayilik.',
    maddeler: ['Marka ve hazır operasyon modeli', 'Kurulum + saha desteği', 'Know-how ve eğitim'] },
  { icon: Code2, renk: 'purple', baslik: 'Sadece Yazılım', ozet: 'Kendi markan, bizim altyapımız.',
    maddeler: ['Tüm paneller ve uygulamalar', 'Kendi markanla kullanım', 'Mevcut şirketini taşı'] },
];

const ADIMLAR = [
  { no: '01', baslik: 'Başvur', metin: 'Formu doldur, birkaç dakika sürer.' },
  { no: '02', baslik: 'Tanışma & Keşif', metin: 'Şehrini ve hedefini konuşur, modeli netleştiririz.' },
  { no: '03', baslik: 'Kurulum & Eğitim', metin: 'Sistemi kurar, panel ve uygulamaları hazırlarız.' },
  { no: '04', baslik: 'Yayına Al', metin: 'Restoran ve kuryelerle operasyonu başlat.' },
];

const SSS = [
  { s: 'Teknik bilgi gerekir mi?', c: 'Hayır. Tüm sistem kurulu gelir; paneller sade ve Türkçedir, kurulum ve eğitim bizden.' },
  { s: 'Ne kadar sürede yayına girerim?', c: 'Hazır altyapı sayesinde kısa sürede başlarsın; net süreyi şehrine ve modele göre görüşmede belirleriz.' },
  { s: 'Franchise mı, sadece yazılım mı?', c: 'Sıfırdan kurup markayı istiyorsan Franchise + Yazılım; kendi markan ve ekibin varsa Sadece Yazılım uygundur.' },
  { s: 'Platform siparişleri çalışır mı?', c: 'Evet. Getir, Trendyol, Migros, Yemeksepeti, Adisyo gibi entegrasyonlar sisteme dahildir.' },
  { s: 'Jeton (kontör) sistemi nasıl işler?', c: 'Teslimatlar kontörle işler; bakiyen, otomatik düşümler ve tüm işlem geçmişi panelde şeffaftır.' },
  { s: 'Destek alıyor muyum?', c: 'Evet, kurulumdan sonra da teknik ve operasyon desteği devam eder.' },
];

export default function BayilikPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [formType, setFormType] = useState('company');

  useEffect(() => {
    document.title = 'AgrosJet Bayilik — Kurye işini A’dan Z’ye hazır sistemle kur';
    captureUtm();
  }, []);

  const basvur = () => { setFormType('company'); setModalOpen(true); };
  const headerSelect = (type) => { setFormType(type || 'company'); setModalOpen(true); };

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="bayilik-page">
      <HeaderV2 onApplySelect={headerSelect} />

      <main>
        {/* ======================= HERO (daima koyu) ======================= */}
        <section className="relative overflow-hidden bg-slate-950 text-white">
          {/* arka plan görseli */}
          <img {...LANDING_IMAGES.showcaseDark} sizes="100vw" alt="" aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover object-center opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/70 to-slate-950" />
          <div className="absolute inset-0 neon-grid-bg opacity-40" />
          <div className="absolute -top-20 left-1/4 h-[360px] w-[360px] rounded-full bg-fuchsia-700/25 blur-[130px] animate-neon-pulse" />
          <div className="absolute top-10 right-1/4 h-[320px] w-[320px] rounded-full bg-orange-600/20 blur-[130px]" />

          <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-6 pt-16 pb-16 sm:pt-24 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs backdrop-blur sm:text-sm">
                <Sparkles className="h-4 w-4 text-orange-400" /> Hazır kurye altyapısı · Franchise ya da sadece yazılım
              </span>
              <h1 className="mt-6 font-heading text-4xl font-extrabold leading-tight sm:text-5xl">
                Kurye işini <span className="neon-text-orange">A’dan Z’ye</span> hazır sistemle kur
              </h1>
              <p className="mt-5 max-w-xl text-base text-white/70 sm:text-lg">
                Otomatik atamadan AI rotasına, jeton sisteminden canlı takibe — operasyonun ihtiyacı olan
                her şey tek panelde. İster tam franchise bayilik, ister sadece yazılım.
              </p>
              <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
                <button onClick={basvur} className="neon-btn-orange flex h-12 w-full items-center justify-center gap-1.5 rounded-xl px-8 font-semibold text-white sm:w-auto" data-testid="bayilik-hero-cta">
                  Hemen Başvur <ArrowRight className="h-4 w-4" />
                </button>
                <a href="#sistem" className="text-sm text-white/70 underline underline-offset-4 hover:text-white">Sistemi incele</a>
              </div>
              <p className="mt-4 text-xs text-white/50">Başvuru ücretsizdir · En kısa sürede size dönüş yaparız</p>
            </div>

            <div className="flex justify-center lg:justify-end">
              <CourierApp />
            </div>
          </div>
        </section>

        {/* ======================= GÜVEN ŞERİDİ ======================= */}
        <section className="border-y border-border bg-card/40">
          <div className="mx-auto grid max-w-5xl grid-cols-2 gap-6 px-6 py-8 sm:grid-cols-4">
            {GUVEN.map((g) => (
              <div key={g.l} className="text-center">
                <div className="font-heading text-3xl font-extrabold text-primary sm:text-4xl">
                  <Counter to={g.n} suffix={g.suffix} />
                </div>
                <p className="mt-1 text-xs text-muted-foreground sm:text-sm">{g.l}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ======================= SİSTEM (panel mockup) ======================= */}
        <section id="sistem" className="px-6 py-16 sm:py-24">
          <div className="mx-auto max-w-6xl">
            <Reveal className="mx-auto max-w-2xl text-center">
              <span className="text-sm font-semibold uppercase tracking-wider text-primary">Tek panel, tüm operasyon</span>
              <h2 className="mt-2 font-heading text-3xl font-bold sm:text-4xl">Canlı harita, otomatik atama, AI rota</h2>
              <p className="mt-3 text-muted-foreground">
                Siparişler düşer, sistem en uygun kuryeyi seçer, rotayı optimize eder — sen sadece izlersin.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
              <Reveal><Dashboard /></Reveal>
              <Reveal delay={0.1} className="space-y-4">
                {[
                  [Zap, 'Otomatik atama', 'Elle kurye seçme derdi yok; sistem saniyeler içinde atar.'],
                  [Route, 'Akıllı optimizasyon', 'Mesafe + adalet + maliyet birlikte; AI en verimli dağıtımı kurar.'],
                  [MapPin, 'Canlı takip', 'Tüm kuryeler haritada; durum, ETA ve yol uyarıları anlık.'],
                  [Coins, 'Jeton sistemi', 'Her teslimat kontörle; bakiye ve işlem geçmişi şeffaf.'],
                ].map(([I, b, m]) => (
                  <div key={b} className="flex gap-4 rounded-2xl border border-border bg-card p-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><I className="h-5 w-5" /></div>
                    <div>
                      <h3 className="font-heading font-semibold">{b}</h3>
                      <p className="mt-0.5 text-sm text-muted-foreground">{m}</p>
                    </div>
                  </div>
                ))}
              </Reveal>
            </div>
          </div>
        </section>

        {/* ======================= ÖZELLİK GRID (A'dan Z'ye) ======================= */}
        <section id="features" className="border-y border-border bg-card/40 px-6 py-16 sm:py-24">
          <div className="mx-auto max-w-6xl">
            <Reveal className="mx-auto max-w-2xl text-center">
              <h2 className="font-heading text-3xl font-bold sm:text-4xl">Her şey kutudan hazır gelir</h2>
              <p className="mt-3 text-muted-foreground">Sıfırdan yazılım geliştirmene gerek yok — A’dan Z’ye operasyonun tamamı sistemde.</p>
            </Reveal>
            <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {OZELLIKLER.map((o, i) => (
                <Reveal key={o.baslik} delay={(i % 3) * 0.06}>
                  <div className="group h-full rounded-2xl border border-border bg-background p-6 transition-all hover:-translate-y-1 hover:border-primary/40 hover:shadow-lg">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                      <o.icon className="h-5 w-5" />
                    </div>
                    <h3 className="mt-4 font-heading text-lg font-semibold">{o.baslik}</h3>
                    <p className="mt-2 text-sm text-muted-foreground">{o.metin}</p>
                  </div>
                </Reveal>
              ))}
            </div>

          </div>
        </section>

        {/* ======================= ÖZELLİK SPOTLIGHT'LARI ======================= */}
        <section className="px-6 py-14 sm:py-20">
          <div className="mx-auto max-w-6xl space-y-16 sm:space-y-24">
            {/* Jeton */}
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
              <Reveal><MiniJeton /></Reveal>
              <Reveal delay={0.1}>
                <span className="text-sm font-semibold uppercase tracking-wider text-primary">Ön ödemeli & şeffaf</span>
                <h3 className="mt-2 font-heading text-2xl font-bold sm:text-3xl">Jeton (Kontör) Sistemi</h3>
                <p className="mt-3 text-muted-foreground">Her teslimat kontörle işler. Bakiye, otomatik düşümler ve tüm işlem geçmişi panelde anlık ve şeffaf — kim ne harcadı, ne zaman yüklendi, hepsi kayıtlı.</p>
                <ul className="mt-5 space-y-2">
                  {['Teslimat başına otomatik düşüm', 'Bakiye ve yükleme takibi', 'Detaylı işlem geçmişi', 'Şirket ve kurye bazında raporlama'].map((x) => (
                    <li key={x} className="flex items-center gap-2 text-sm"><CheckCircle2 className="h-4 w-4 text-primary" />{x}</li>
                  ))}
                </ul>
              </Reveal>
            </div>

            {/* Vardiya (ters) */}
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
              <Reveal className="order-2 lg:order-1">
                <span className="text-sm font-semibold uppercase tracking-wider text-primary">Adil ve otomatik</span>
                <h3 className="mt-2 font-heading text-2xl font-bold sm:text-3xl">Vardiya, Rütbe & Performans</h3>
                <p className="mt-3 text-muted-foreground">Haftalık vardiya planı, check-in, takas ve kademeli seçim; rütbe ve Çalışma Puanı ile performansa göre adil dağıtım. Kurye yönetimi kendi kendine döner.</p>
                <ul className="mt-5 space-y-2">
                  {['Haftalık plan + ön check-in', 'Vardiya takası ve ek kontenjan', 'Rütbe dilimleri ve Çalışma Puanı', 'Kademeli (alevli) seçim'].map((x) => (
                    <li key={x} className="flex items-center gap-2 text-sm"><CheckCircle2 className="h-4 w-4 text-primary" />{x}</li>
                  ))}
                </ul>
              </Reveal>
              <Reveal delay={0.1} className="order-1 lg:order-2"><MiniVardiya /></Reveal>
            </div>

            {/* Mutabakat */}
            <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
              <Reveal><MiniMutabakat /></Reveal>
              <Reveal delay={0.1}>
                <span className="text-sm font-semibold uppercase tracking-wider text-primary">Muhasebe entegre</span>
                <h3 className="mt-2 font-heading text-2xl font-bold sm:text-3xl">POS Mutabakat & e-Fatura</h3>
                <p className="mt-3 text-muted-foreground">Gün sonu nakit/kart/POS mutabakatı sipariş bazında; eLogo ile e-fatura otomatik kesilir, hakediş ve tahsilat tek akışta. Kâr-zarar raporları hazır.</p>
                <ul className="mt-5 space-y-2">
                  {['Nakit / kart / POS mutabakatı', 'eLogo e-fatura entegrasyonu', 'Hakediş ve tahsilat takibi', 'Kâr-zarar ve muhasebe raporları'].map((x) => (
                    <li key={x} className="flex items-center gap-2 text-sm"><CheckCircle2 className="h-4 w-4 text-primary" />{x}</li>
                  ))}
                </ul>
              </Reveal>
            </div>
          </div>
        </section>

        {/* ======================= ENTEGRASYONLAR (gerçek şerit, 30+) ======================= */}
        <IntegrationsSection />

        {/* ======================= MÜŞTERİ DENEYİMİ ======================= */}
        <section className="px-6 py-16 sm:py-24">
          <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 lg:grid-cols-2">
            <Reveal className="order-2 lg:order-1">
              <span className="text-sm font-semibold uppercase tracking-wider text-primary">Markalı müşteri uygulaması</span>
              <h2 className="mt-2 font-heading text-3xl font-bold sm:text-4xl">Kendi şehrinin sipariş uygulaması</h2>
              <p className="mt-3 text-muted-foreground">
                Agros Kapında müşteri uygulaması hazır gelir: restoran ve market siparişi, canlı takip,
                kampanyalar ve bildirimler. Müşterilerin senin sisteminden sipariş verir.
              </p>
              <ul className="mt-6 space-y-3">
                {['Restoran + market + su + çiçek', 'Canlı sipariş takibi ve bildirim', 'Kampanya ve indirim yönetimi', 'iOS & Android hazır'].map((m) => (
                  <li key={m} className="flex items-center gap-2 text-sm"><CheckCircle2 className="h-4 w-4 text-primary" />{m}</li>
                ))}
              </ul>
              <Button onClick={basvur} className="mt-7">Hemen başvur <ArrowRight className="ml-1.5 h-4 w-4" /></Button>
            </Reveal>
            <Reveal delay={0.1} className="order-1 flex justify-center lg:order-2">
              <PhoneApp />
            </Reveal>
          </div>
        </section>

        {/* ======================= MODELLER ======================= */}
        <section id="modeller" className="border-y border-border bg-card/40 px-6 py-16 sm:py-24">
          <div className="mx-auto max-w-5xl">
            <Reveal className="text-center">
              <h2 className="font-heading text-3xl font-bold sm:text-4xl">İki model, tek güçlü sistem</h2>
              <p className="mt-2 text-muted-foreground">Sana uygun olanı seç; başvuruda belirtebilirsin.</p>
            </Reveal>
            <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {MODELLER.map((m, i) => (
                <Reveal key={m.baslik} delay={i * 0.08}>
                  <div className={`flex h-full flex-col rounded-2xl border bg-background p-7 ${m.renk === 'orange' ? 'neon-border-orange' : 'neon-border-purple'}`}>
                    <m.icon className={`h-9 w-9 ${m.renk === 'orange' ? 'text-orange-500' : 'text-violet-500'}`} />
                    <h3 className="mt-4 font-heading text-xl font-bold">{m.baslik}</h3>
                    <p className={`mt-1 font-medium ${m.renk === 'orange' ? 'text-orange-500' : 'text-violet-500'}`}>{m.ozet}</p>
                    <ul className="mt-4 flex-1 space-y-2">
                      {m.maddeler.map((x) => (
                        <li key={x} className="flex items-center gap-2 text-sm text-muted-foreground"><CheckCircle2 className="h-4 w-4 text-primary" />{x}</li>
                      ))}
                    </ul>
                    <Button variant="outline" onClick={basvur} className="mt-6 w-full">Bu modelle başvur</Button>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* ======================= NASIL ÇALIŞIR ======================= */}
        <section className="px-6 py-16 sm:py-24">
          <div className="mx-auto max-w-5xl">
            <Reveal className="text-center">
              <h2 className="font-heading text-3xl font-bold sm:text-4xl">Nasıl başlıyorsun?</h2>
            </Reveal>
            <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
              {ADIMLAR.map((a, i) => (
                <Reveal key={a.no} delay={i * 0.07}>
                  <div className="relative h-full rounded-2xl border border-border bg-card p-6">
                    <span className="font-heading text-4xl font-extrabold text-primary/20">{a.no}</span>
                    <h3 className="mt-2 font-heading text-lg font-semibold">{a.baslik}</h3>
                    <p className="mt-2 text-sm text-muted-foreground">{a.metin}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* ======================= SSS ======================= */}
        <section className="border-t border-border px-6 py-16 sm:py-24">
          <div className="mx-auto max-w-3xl">
            <Reveal className="text-center">
              <h2 className="font-heading text-3xl font-bold sm:text-4xl">Sık sorulan sorular</h2>
            </Reveal>
            <div className="mt-8 space-y-3">
              {SSS.map((f) => (
                <details key={f.s} className="group rounded-xl border border-border bg-card p-5">
                  <summary className="flex cursor-pointer list-none items-center justify-between font-medium">
                    {f.s}
                    <span className="text-xl leading-none text-primary transition-transform group-open:rotate-45">+</span>
                  </summary>
                  <p className="mt-3 text-sm text-muted-foreground">{f.c}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* ======================= SON CTA (koyu) ======================= */}
        <section className="relative overflow-hidden bg-slate-950 px-6 py-20 text-white sm:py-28">
          <img {...LANDING_IMAGES.ctaDark} sizes="100vw" alt="" aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover object-center opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/80 via-slate-950/75 to-slate-950" />
          <div className="absolute left-1/2 top-1/2 h-[420px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-fuchsia-700/20 blur-[140px] animate-neon-pulse" />
          <Reveal className="relative mx-auto max-w-2xl text-center">
            <Headset className="mx-auto h-10 w-10 text-orange-400" />
            <h2 className="mt-4 font-heading text-3xl font-bold sm:text-4xl">Şehrinde AgrosJet’i başlatmaya hazır mısın?</h2>
            <p className="mt-3 text-white/70">Başvurunu bırak; en kısa sürede dönelim ve detayları birlikte konuşalım.</p>
            <button onClick={basvur} className="neon-btn-orange mx-auto mt-8 flex h-12 items-center justify-center gap-1.5 rounded-xl px-10 font-semibold text-white" data-testid="bayilik-final-cta">
              Hemen Başvur <ArrowRight className="h-4 w-4" />
            </button>
          </Reveal>
        </section>
      </main>

      <Footer />

      <ApplicationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} defaultForm={formType} />
      <Toaster position="top-right" richColors />
    </div>
  );
}
